import { createColumnHelper } from '@tanstack/react-table';
import { dayjs } from '../../../utils/dayjs';
import { OnViolationStatusChange, ViolationNode } from '../types';
import { TypeCellRenderer } from './type-cell-renderer';
import { DetailsCellRenderer } from './details-cell-renderer';
import { StatusCellRenderer } from './status-cell-renderer';
import { StatusHeaderRenderer } from './status-header-renderer';

const columnHelper = createColumnHelper<ViolationNode>();

export const violationsColumnDefs = (
  onStatusChange: OnViolationStatusChange
) => [
  columnHelper.accessor('rawType', {
    header: 'Potential Violation',
    cell: (info) => <TypeCellRenderer value={info.getValue()} />,
  }),
  columnHelper.accessor('created', {
    header: 'Detected',
    cell: (info) => {
      return dayjs.unix(info.getValue()).format('MM-DD-YYYY');
    },
  }),
  columnHelper.accessor('source', {
    header: 'Additional Details',
    cell: (info) => <DetailsCellRenderer data={info.row.original} />,
  }),
  columnHelper.accessor('status', {
    header: () => <StatusHeaderRenderer />,
    meta: {
      className: 'w-[120px] min-w-[120px]',
    },
    cell: (info) => {
      return (
        <StatusCellRenderer
          // It is important to set the key because the component will be reused if key isn't sent
          // and we don't want that because these components have their own internal state
          key={info.row.original.id}
          value={info.getValue()}
          data={info.row.original}
          onStatusChange={onStatusChange}
        />
      );
    },
  }),
];
